import { render, staticRenderFns } from "./CombDesigns.vue?vue&type=template&id=f6cbc864&scoped=true&"
import script from "./CombDesigns.vue?vue&type=script&lang=js&"
export * from "./CombDesigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cbc864",
  null
  
)

export default component.exports